import Vue from 'vue';
export default new Vue();


// WEBPACK FOOTER //
// ./src/modules/workorder/api/bus.js